import VueHtml2Canvas from 'vue-html2canvas'

export default ({ app, router, Vue }) => {
  Vue.use(VueHtml2Canvas)
}
